<template>
  <div>
    <!-- 弹窗组件 -->
    <div v-if="showModal" class="modal-overlay">
      <div class="modal-content">
        <div class="modal-header">
          <h2>马上报名免费注册试用轻变聚合产品，开启您的商业化之旅！</h2>
          <span class="close-btn" @click.stop="closeModal">&times;</span>
        </div>
        <div class="modal-description">
          留下您的联系方式，我们变现的顾问会尽快与您取得联系，为您开通免费试用账号！
        </div>
        <div class="modal-body">
          <div class="input-container">
            <input type="text" v-model="formData.name" placeholder="请输入您的姓名" class="input-field">
            <input type="tel" v-model="formData.phone" placeholder="请输入您的手机号码" class="input-field">
            <div class="verification-code-container">
              <input type="text" v-model="formData.verificationCode" placeholder="请输入验证码" class="input-field verification-input">
              <button class="send-code-btn" @click="sendVerificationCode" :disabled="countdown > 0">{{ countdown > 0 ? countdown + '秒后重发' : '发送验证码' }}</button>
            </div>
          </div>
          <div class="input-container">
            <input type="text" v-model="formData.compley" placeholder="请输入您的公司名称" class="input-field">
            <input type="text" v-model="formData.appName" placeholder="请输入您的APP名称" class="input-field">
          </div>
        </div>
        <div class="modal-footer">
          <button class="submit-btn" @click="submitForm">立即提交</button>
        </div>
      </div>
    </div>
    <!-- 右侧悬浮按钮 -->
    <div class="floating-buttons">
      <div class="floating-btn" @click="consultTo('phone')">
        <img src="https://cdn.huimiaokeji.com/icon_dedicated_30@2x.png" alt="客服专线" width="30" height="30"/>
        <p>客服专线</p>
      </div>
      <div class="floating-btn" @click="consultTo('wechat')">
        <img src="https://cdn.huimiaokeji.com/icon_online_30@2x.png" alt="微信咨询" width="30" height="30"/>
        <p>微信咨询</p>
      </div>
      <div class="floating-btn" @click="consultTo('admin')">
        <img src="https://cdn.huimiaokeji.com/icon_appointment_30@2x.png" alt="预约演示" width="30" height="30"/>
        <p>预约演示</p>
      </div>
      <div class="floating-btn" @click="consultTo('bxzx')">
        <img src="https://cdn.huimiaokeji.com/icon_register_30@2x.png" alt="注册试用" width="30" height="30"/>
        <p>注册试用</p>
      </div>
    </div>
    <!-- 微信二维码弹窗 -->
    <div v-if="showWechatQRCode" class="wechat-qrcode-container" @click.stop="closeWechatQRCode">
      <div class="wechat-qrcode-content">
        <img src="https://cdn.huimiaokeji.com/qr_zjy_zhixun_wechat.png" alt="微信二维码" class="qrcode-image"/>
        <p class="qrcode-text">扫码添加微信咨询</p>
      </div>
    </div>
    <!-- 客服专线弹窗 -->
    <div v-if="showPhoneQRCode" class="wechat-qrcode-container" @click="closePhoneQRCode">
      <div class="wechat-qrcode-content" style="background: #0a00a5;color: #ffffff;" @click.stop>
        <p class="qrcode-text" style="color: #ffffff;">
          17505810773
          <span @click.stop="copyPhoneNumber"> 复制</span>
        </p>
        <p class="qrcode-text" style="color: #ffffff;">7*24小时在线</p>
      </div>
    </div>
  </div>
</template>

<script>
import { addContactUs, getSendSms } from '../api/index.js';

export default {
  name: 'FloatingModal',
  data() {
    return {
      showModal: false,
      showWechatQRCode: false,
      showPhoneQRCode: false,
      formData: {
        name: '',
        compley: '',
        appName: '',
        phone: '',
        verificationCode: ''
      },
      countdown: 0,
      countdownTimer: null
    }
  },
  methods: {
    // 复制电话号码到剪贴板
    copyPhoneNumber() {
      const phoneNumber = '17505810773';
      navigator.clipboard.writeText(phoneNumber).then(() => {
        alert('电话号码已复制到剪贴板');
      }).catch(err => {
        console.error('复制失败:', err);
        // 降级方案：使用传统方法
        const textArea = document.createElement('textarea');
        textArea.value = phoneNumber;
        document.body.appendChild(textArea);
        textArea.select();
        try {
          document.execCommand('copy');
          alert('电话号码已复制到剪贴板');
        } catch (err) {
          console.error('传统方法复制也失败:', err);
          alert('复制失败，请手动复制电话号码');
        }
        document.body.removeChild(textArea);
      });
    },
    consultTo(url) {
      if (url == 'bxzx') {
        this.showPhoneQRCode = false;
        this.showWechatQRCode = false;
        this.showModal = true;
      } else if (url == 'admin') {
        this.showPhoneQRCode = false;
        this.showWechatQRCode = false;
        window.open('https://admin.huimiaokeji.com');
      } else if (url == 'wechat') {
        this.showPhoneQRCode = false;
        this.showWechatQRCode = !this.showWechatQRCode;
      } else if (url == 'phone') {
        this.showWechatQRCode = false;
        this.showPhoneQRCode = !this.showPhoneQRCode;
      }
    },
    closeWechatQRCode() {
      this.showWechatQRCode = false;
    },
    closePhoneQRCode() {
      this.showPhoneQRCode = false;
    },
    closeModal() {
      this.showModal = false;
      this.showPhoneQRCode = false;
      this.showWechatQRCode = false;
    },
    // 发送验证码方法
    async sendVerificationCode() {
      if (!/^1[3-9]\d{9}$/.test(this.formData.phone)) {
        alert('请输入正确的手机号码');
        return;
      }
      let res = await getSendSms(this.formData.phone);
      if (res.code != 200) {
        alert(res.msg);
        return;
      } else {
        this.countdown = 60;
        this.countdownTimer = setInterval(() => {
          this.countdown--;
          if (this.countdown <= 0) {
            clearInterval(this.countdownTimer);
          }
        }, 1000);
        alert('验证码已发送，请注意查收');
        return;
      }
    },
    // 提交表单方法
    async submitForm() {
      if (!this.formData.name) {
        alert('请输入您的姓名');
        return;
      }
      if (!this.formData.phone) {
        alert('请输入您的手机号码');
        return;
      }
      if (!this.formData.verificationCode) {
        alert('请输入验证码');
        return;
      }
      let res = await addContactUs(this.formData);
      if (res.code == 200) {
        this.showModal = false;
        this.formData = {
          name: '',
          compley: '',
          appName: '',
          phone: '',
          verificationCode: ''
        };
        alert('提交成功，我们会尽快与您联系');
      } else {
        alert(res.msg);
      }
    }
  },
  // 组件销毁时清除定时器
  beforeDestroy() {
    if (this.countdownTimer) {
      clearInterval(this.countdownTimer);
    }
  }
}
</script>

<style scoped lang="less">
/* 弹窗样式 */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  width: 680px;
  height: 474px;
  background: #FFFFFF;
  border-radius: 8px;
  padding: 0;
  position: relative;
}

.modal-header {
  height: 98px;
  display: flex;
  background: #0B00B5;
  font-size: 18px;
  align-items: center;
  justify-content: center;
  position: relative;
  color: #FFFFFF;
  border-bottom: 1px solid #EEF1F7;
}

.modal-header h2 {
  margin: 0;
  font-size: 16px;
  color: #FFFFFF;
  font-weight: 600;
}

.close-btn {
  position: absolute;
  right: 20px;
  top: 42%;
  transform: translateY(-50%);
  font-size: 20px;
  cursor: pointer;
  color: #eee;
}

.modal-description {
  height: 16px;
  text-align: center;
  margin-top: 20px;
  margin-bottom: 30px;
  font-size: 16px;
  color: #666;
}

.modal-body {
  display: flex;
  justify-content: space-between;
  padding: 0 40px;
  margin-bottom: 30px;
  margin-top: 20px;
}

.input-container {
  display: flex;
  flex-direction: column;
  width: 48%;
  gap: 16px;
}

.input-field {
  height: 40px;
  background: #EEF1F7;
  border: none;
  border-radius: 4px;
  padding: 0 12px;
  font-size: 14px;
  outline: none;
}

.input-field::placeholder {
  color: #999;
}

.modal-footer {
  display: flex;
  justify-content: center;
  margin-top: 50px;
}

.submit-btn {
  width: 600px;
  height: 50px;
  background: #0B00B5;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  outline: none;
}

.submit-btn:hover {
  background: #0a00a5;
}

.verification-code-container {
  position: relative;
  display: inline-block;
  width: 100%;
}

.verification-input {
  padding-right: 100px !important;
}

.send-code-btn {
  position: absolute;
  right: 4px;
  top: 50%;
  transform: translateY(-50%);
  height: 32px;
  color: #0B00B5;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
  white-space: nowrap;
}

.send-code-btn:disabled {
  cursor: not-allowed;
}

// 右侧悬浮按钮样式
.floating-buttons {
  position: fixed;
  top: 335px;
  right: 0;
  z-index: 999;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.floating-btn {
  width: 70px;
  height: 70px;
  background: #0B00B5;
  cursor: pointer;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  transition: all 0.3s ease;

  &:hover {
    background: #0a00a5;
    transform: translateY(-2px);
  }

  img {
    margin-bottom: 2px;
    margin-top: 6px;
    margin-left: 20px;
  }

  p {
    margin: 0;
    font-size: 12px;
    color: #fff;
    text-align: center;
  }
}

/* 微信二维码弹窗样式 */
.wechat-qrcode-container {
  position: fixed;
  top: 335px;
  right: 70px;
  z-index: 998;
  display: flex;
  align-items: center;
  justify-content: center;
}

.wechat-qrcode-content {
  background: white;
  padding: 15px;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.15);
  text-align: center;
  animation: slideIn 0.3s ease-out;
}

.qrcode-image {
  width: 120px;
  height: 120px;
  margin-bottom: 10px;
}

.qrcode-text {
  margin: 5px 0;
  font-size: 14px;
  color: #333;
}

@keyframes slideIn {
  from {
    transform: translateX(20px);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/floating-modal.vue